
type AdvertiserNameFields = {
  userDefinedMerchant: string
  finalDomain: string
  advertiser?: {
    name: string
  }
  advertiserSnapshot?:{
    name: string
  }
  closedMerchant?: boolean;
}

export function getAdvertiserName(auditData: AdvertiserNameFields): string {

  let advertiserName =
    auditData.userDefinedMerchant ||
    auditData.advertiserSnapshot?.name ||
    auditData.finalDomain ||
    'None found'
  
  if (auditData.closedMerchant) {
    advertiserName += ` (Closed Advertiser)`
  }

  return advertiserName
}